/* eslint-disable max-len */
import styled, { css, keyframes, withTheme } from 'styled-components';

const animation = keyframes`
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;
const animationRule = css`
  ${animation} 2s infinite linear;
`;
const Shimmer = styled.span`
  display: block;
  border-radius: 24px;
  animation: ${animationRule};
  background: #1d3042;
  background-image: ${(props) =>
    props.theme.palette.type === 'dark'
      ? 'linear-gradient(to right, #1d3042 0%, #21384F 20%, #21384F 40%, #1d3042 100%)'
      : 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(249,249,249,1) 48%, rgba(240,240,240,1) 100%)'};

  background-size: 1000px 100%;
  height: 32px;

  &.tabsDarkShimmer {
    background-image: ${(props) =>
      props.theme.palette.type === 'dark'
        ? 'linear-gradient(to right, #070d12 0%, #142433 20%, #142433 40%, #070d12 100%)'
        : 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(249,249,249,1) 48%, rgba(240,240,240,1) 100%)'};
  }

  &.tabBoxTotalShimmer,
  &.tabBoxTitleShimmer {
    height: 22px;
  }

  &.tabBoxShimmer {
    margin: 27px 0 20px;
    height: 17px;
  }
`;
export default withTheme(Shimmer);
